// Establish interval to update timer each second
  setInterval(() => {
    // Get current day of week and current time... for use with trigger conditions
    var sdsTimer$nowDay = new Date().getUTCDay();
    var sdsTimer$nowTime = new Date().getTime();
  	// Establish daily shipping cutoff time... 12:00pm EST = 17:00 UTC, 12:00pm EDT = 16:00 UTC
    var sdsTimer$endTime = new Date().setUTCHours(17, 0, 0);
    // Math to determine time remaining to cutoff
    var sdsTimer$cdTime = sdsTimer$endTime - sdsTimer$nowTime;
    var sdsTimer$cdHours = Math.floor(sdsTimer$cdTime / 3600000);
    var sdsTimer$cdMinutes = Math.floor(sdsTimer$cdTime / 60000 - sdsTimer$cdHours * 60);
  	// Magic to make everything work...
    if (
      (sdsTimer$nowDay == 1
        || sdsTimer$nowDay == 2
        || sdsTimer$nowDay == 3
        || sdsTimer$nowDay == 4
        || sdsTimer$nowDay == 5)
      && sdsTimer$nowTime + 60000 < sdsTimer$endTime
    ) {
      document.getElementById('sds-timer-pdp').innerHTML = `&#9202; Order in the next <span id="sds-timer-hh"></span> and <span id="sds-timer-mm"></span> and it ships today!`;
      document.getElementById('sds-timer-hh').innerHTML = `${sdsTimer$cdHours} hours`;
      document.getElementById('sds-timer-mm').innerHTML = `${sdsTimer$cdMinutes} minutes`;
      document.getElementById('sds-timer-pdp').style.display = 'block';
    }
    else if (
      (sdsTimer$nowDay == 0
        || sdsTimer$nowDay == 1
        || sdsTimer$nowDay == 2
        || sdsTimer$nowDay == 3
        || sdsTimer$nowDay == 4)
      && sdsTimer$nowTime + 60000 >= sdsTimer$endTime
    ) {
      document.getElementById('sds-timer-pdp').innerHTML = `&#9202; Ships within 24 hours!`;
      document.getElementById('sds-timer-pdp').style.display = 'block';
    }
    else {
      document.getElementById('sds-timer-pdp').innerHTML = `&#9202; Ships next business day!`;
      document.getElementById('sds-timer-pdp').style.display = 'block';
    }
  }, 1000);